export class SqlSetupCheckResult {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "status",
            "baseName": "status",
            "type": "SqlSetupCheckStatus",
            "format": ""
        },
        {
            "name": "missingObjects",
            "baseName": "missingObjects",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "checkedAt",
            "baseName": "checkedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "error",
            "baseName": "error",
            "type": "string",
            "format": ""
        },
        {
            "name": "runId",
            "baseName": "runId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SqlSetupCheckResult.attributeTypeMap;
    }
    constructor() {
    }
}
